import React from 'react';

export default function SeasonPlanerPage() {
  return <div>SeasonPlanerPage</div>;
}
